import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { LoginComponent } from "../pages/login/login.component";
import { PageNotFoundComponent } from "../pages/page-not-found/page-not-found.component";
import { GaiaHandlerComponent } from "../pages/login/gaia-handler/gaia-handler.component";

import { AdminAuthGuardService } from "./admin-auth.guard";
import { AuthGuardService } from "./auth-guard.service";
import { NoAuthGuardService } from "./no-auth-guard.service";
import { SuperAdminAuthGuardService } from "./superadmin-auth.guard";

export const routes: Routes = [
  {
    path: "",
    component: LoginComponent,
    canActivate: [NoAuthGuardService],
  },
  {
    path: "gaia_handler",
    component: GaiaHandlerComponent,
  },
  { path: "**", component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],

  exports: [RouterModule],

  providers: [
    AdminAuthGuardService,
    AuthGuardService,
    NoAuthGuardService,
    SuperAdminAuthGuardService,
  ],
})
export class AuthNRoutingModule {}
